var _path, _g, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstatementreq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1788_11864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 23,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 2.51367H25.0659V27.3305H3.75V2.51367Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1788_11864)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46635 4.38909C7.3951 4.38909 5.6751 6.06659 5.62635 8.13534V21.5041C5.5801 23.6453 7.2676 25.4091 9.3876 25.4566H19.4676C21.5538 25.3703 23.2063 23.6366 23.1913 21.5116V10.4241L17.3976 4.38909H9.48135H9.46635ZM9.48138 27.3312H9.34513C6.19263 27.2599 3.68263 24.6374 3.75138 21.4837V8.11242C3.82388 5.01117 6.38513 2.51367 9.46388 2.51367H9.48513H17.7976C18.0526 2.51367 18.2964 2.61742 18.4739 2.80117L24.8051 9.39742C24.9726 9.57117 25.0664 9.80492 25.0664 10.0462V21.5037C25.0889 24.6399 22.6464 27.2024 19.5051 27.3299L9.48138 27.3312Z",
    fill: "#CA1100"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1225 11.228H20.6787C18.3912 11.2218 16.5312 9.3568 16.5312 7.0718V3.43555C16.5312 2.91805 16.9512 2.49805 17.4687 2.49805C17.9862 2.49805 18.4062 2.91805 18.4062 3.43555V7.0718C18.4062 8.3268 19.4275 9.3493 20.6812 9.35305H24.1225C24.64 9.35305 25.06 9.77305 25.06 10.2905C25.06 10.808 24.64 11.228 24.1225 11.228",
    fill: "#CA1100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2354 20.1348H10.4854C9.96785 20.1348 9.54785 19.7148 9.54785 19.1973C9.54785 18.6798 9.96785 18.2598 10.4854 18.2598H17.2354C17.7529 18.2598 18.1729 18.6798 18.1729 19.1973C18.1729 19.7148 17.7529 20.1348 17.2354 20.1348",
    fill: "#CA1100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6794 15.4434H10.4844C9.96687 15.4434 9.54688 15.0234 9.54688 14.5059C9.54688 13.9884 9.96687 13.5684 10.4844 13.5684H14.6794C15.1969 13.5684 15.6169 13.9884 15.6169 14.5059C15.6169 15.0234 15.1969 15.4434 14.6794 15.4434",
    fill: "#CA1100"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstatementreq);
export default __webpack_public_path__ + "static/media/estatementreq.b3c6a87889065adba30262f1998271f0.svg";
export { ForwardRef as ReactComponent };